export const ADD_CATEGORY='ADD_CATEGORY'
export const ADD_CATEGORY_SUCCESS= 'ADD_CATEGORY_SUCCESS'
export const ADD_CATEGORY_ERROR= 'ADD_CATEGORY_ERROR'

export const AddCategory= (data) => ({
    type: ADD_CATEGORY,
    payload: data
})